module.exports = __webpack_public_path__ + "img/cloud-banner.e158b29a.png";